import * as actionType from './ActionType';

export const setCountryCode = (countryCOde) => ({
  type: actionType.SET_ONBOARD_COUNTRY_CODE,
  payload: countryCOde
});
